import { render, staticRenderFns } from "./PaintColorCatalog.vue?vue&type=template&id=6e615c9e&scoped=true"
import script from "./PaintColorCatalog.vue?vue&type=script&lang=js"
export * from "./PaintColorCatalog.vue?vue&type=script&lang=js"
import style0 from "./PaintColorCatalog.vue?vue&type=style&index=0&id=6e615c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e615c9e",
  null
  
)

export default component.exports